import { PropsWithChildren } from "react";

import { classNames } from "@helpers/css";

type Props = {
  className?: string;
};

const Placeholder: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  return (
    <div
      className={classNames(
        "text-gray-500 text-sm bg-gray-100 p-6 rounded w-full text-center",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Placeholder;
